<template>
    <transition :css="false" @enter="intro" @leave="outro">
        <div class="AnimatedSprite">
            <img class="AnimatedSprite-image" v-if="source" :src="source">
        </div>
    </transition>
</template>

<script>
    // Controlling FPS with requestAnimationFrame:
    // https://stackoverflow.com/a/19772220/3841699
    export default {
        name: 'AnimatedSprite',
        props: {
            start: {
                type: Number,
                required: true,
            },
            end: {
                type: Number,
                required: true,
            },
            frames: {
                type: Array,
                required: true,
            },
            backwards: {
                type: Boolean,
                default: false,
            },
            fps: {
                type: Number,
                default: 30,
            },
        },
        data() {
            return {
                then: null,
                frame: null,
                paused: false,
            }
        },
        methods: {
            intro(el, done) {
                this.play()
                done()
            },
            outro(el, done) {
                this.paused = true
                done()
            },
            play() {
                const { startFrame, endFrame, backwards } = this
                this.paused = false
                this.frame = backwards ? endFrame : startFrame
                this.then = Date.now()
                return new Promise((resolve, reject) => {
                    try {
                        this.update(resolve)
                    } catch (err) {
                        reject(err)
                    }
                })
            },
            update() {
                const updateLoop = () => {
                    if (this.paused) {
                        this.$emit('complete')
                    } else {
                        this.updateFrame()
                        requestAnimationFrame(updateLoop)
                    }
                }
                updateLoop()
            },
            updateFrame() {
                const { then, fpsInterval } = this
                const now = Date.now()
                const elapsed = now - then
                if (elapsed > fpsInterval) {
                    const { backwards, startFrame, endFrame } = this
                    this.then = now - (elapsed % fpsInterval)
                    if (backwards) {
                        if (this.frame === startFrame) {
                            this.paused = true
                        } else {
                            this.frame--
                        }
                    } else {
                        if (this.frame === endFrame) {
                            this.paused = true
                        } else {
                            this.frame++
                        }
                    }
                }
            },
        },
        computed: {
            fpsInterval() {
                const { fps } = this
                return 1000 / fps
            },
            startFrame() {
                const { start } = this
                return start || 0
            },
            endFrame() {
                const { end, frames } = this
                return end || frames.length - 1
            },
            source() {
                const { backwards, frame, startFrame, endFrame, frames } = this
                let _frame
                if (backwards) {
                    _frame = typeof frame === 'number' ? frame : endFrame
                } else {
                    _frame = typeof frame === 'number' ? frame : startFrame
                }
                return frames[_frame]
            },
        },
    }
</script>

<style src="styles/components/AnimatedSprite.styl" lang="stylus"></style>


// WEBPACK FOOTER //
// src/app/components/AnimatedSprite.vue